<template>
	<div
		class="big-n-filter-wrapper"
		v-bind="$props"
		:disabled="disabled"
		@click="handleClick($event)"
	>
		<div class="big-n-filter-title">
			{{ title }}
		</div>
		<div class="big-n" :style="'font-size:' + numberSize + 'px'">
			<slot />
		</div>
		<div class="big-n-filter-footer">
			<span />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
/**
 * The big number filter is intended to 1. Add value in user experience by showing critical figures or KPIs upfront 2. Drill down and filter further by selecting the big number .Big numbers are often displayed at the top of dashboard with a large font
 */
export default defineComponent({
	name: "BigNumberFilter",
	props: {
		/**
		 * Title  of filter
		 */
		title: {
			type: String,
			default: null,
			required: false
		},
		/**
		 * true | false
		 */
		selected: {
			type: Boolean,
			default: false
		},
		/**
		 * 'default' | 'success' | 'error' | 'inProgress' | 'all' | 'warning' | 'outlined'
		 */
		type: {
			type: String,
			default: "default",
			validator(value) {
				return ["default", "success", "error", "inProgress", "all", "warning", "outlined"].includes(
					value
				);
			}
		},
		numberSize: {
			type: Number,
			default: 32
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event.
			 *
			 * @event click
			 */
			if (!this.disabled) {
				this.$emit("click", e);
			}
		}
	}
});
</script>
<style lang="scss">
@use "sass:map";

$background-color: var(--dashboard-input);
$padding: 12px;
$width: 115px;
$height: 76px;
$title-color: var(--dashboard-font-light);
$number-color: var(--dashboard-font-dark);
$hover: var(--dashboard-element-dark);
$focus: var(--dashboard-primary);

$selected-colors: (
	"success": var(--dashboard-success),
	"error": var(--dashboard-danger),
	"warning": var(--dashboard-warning),
	"inProgress": var(--dashboard-primary),
	"default": var(--dashboard-border-dark),
	"outlined": transparent
);
div.big-n-filter-wrapper {
	background-color: $background-color;
	border-radius: 4px;
	display: inline-flex;
	flex-direction: column;
	justify-content: space-between;
	position: relative;
	// width: $width;
	height: $height;
	cursor: pointer;

	> div.big-n-filter-title {
		font-size: 12px;
		font-weight: bold;
		line-height: 12px;
		text-transform: uppercase;
		color: $title-color;

		padding-top: $padding;
		padding-right: $padding;
		padding-left: $padding;

		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	> div.big-n {
		font-size: 32px;
		font-weight: bold;
		line-height: 32px;
		color: $number-color;

		padding-right: $padding;
		padding-left: $padding;
		display: flex;

		button.icon-count {
			padding-left: 8px;
			padding-right: 8px;
			background-color: var(--dashboard-icon-background-light);
			> .button-content {
				> * {
					margin: 0px 4px 0px 0px;
					&:last-child {
						margin: 0px;
					}
				}
			}
		}

		.icon-count + .icon-count {
			margin-left: 8px;
		}
	}

	> div.big-n-filter-footer {
		height: 8px;
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
		overflow: hidden;
		display: flex;
		position: relative;
		> span {
			position: absolute;
			left: 50%;
			right: 50%;
			bottom: 0px;
			transition: left 0.3s, right 0.3s;
			top: 0px;
		}
	}

	@each $type, $color in $selected-colors {
		&[type="#{$type}"] {
			&[selected] {
				> div.big-n-filter-footer {
					> span {
						left: 0px;
						right: 0px;
						// max-width: 100vw;
						// flex: 1 1 auto;
						background-color: $color;
					}
				}
			}
		}
	}

	&[type="all"] {
		&[selected] {
			> div.big-n-filter-footer {
				> span {
					left: 0px;
					right: 0px;
					background: linear-gradient(
						90deg,
						var(--dashboard-success) 0%,
						var(--dashboard-success) 14%,
						var(--dashboard-primary) 28%,
						var(--dashboard-primary) 42%,
						var(--dashboard-danger) 56%,
						var(--dashboard-danger) 70%,
						var(--dashboard-warning) 94%,
						var(--dashboard-warning) 100%
					);
					// 	background: transparent
					// 		linear-gradient(
					// 			90deg,
					// 			var(--dashboard-border-dark) 0%,
					// 			var(--dashboard-success) 33%,
					// 			var(--dashboard-primary) 60%,
					// 			var(--dashboard-danger) 100%
					// 		)
					// 		0% 0% no-repeat padding-box;
				}
				// > span:nth-child(1) {
				// 	background-color: map-get($selected-colors, "default");
				// }
				// > span:nth-child(2) {
				// 	background-color: map-get($selected-colors, "success");
				// }
				// > span:nth-child(3) {
				// 	background-color: map-get($selected-colors, "inProgress");
				// }
				// > span:nth-child(4) {
				// 	background-color: map-get($selected-colors, "error");
				// }
			}
		}
	}

	&[type="outlined"] {
		background-color: transparent;
		border: 1px solid var(--dashboard-border-dark);
		width: auto;
		min-width: 150px;
	}
	&:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		background-color: $hover;
		border-radius: 4px;
		opacity: 0;
		width: 100%;
		height: 100%;
		transition: opacity 0.2s linear;
	}
	&:active:not([disabled]),
	&:hover:not(:active):not([disabled]) {
		&:before {
			transition: opacity 0.3s linear;
		}
	}

	&:active:not([disabled]) {
		&:before {
			opacity: 0.25;
			cursor: pointer;
		}
	}

	&:hover:not(:active):not([disabled]) {
		&:before {
			opacity: 0.2;
		}
	}

	&:focus:not([disabled]) {
		box-shadow: 0 0 0 2px $focus;
		outline: none;
	}

	&[disabled] {
		filter: opacity(0.3);
		cursor: not-allowed;
	}
}

div.big-n-filter-container {
	overflow-x: auto;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax($width, 1fr));
	grid-gap: 12px;
	padding: 2px;
	grid-auto-flow: column;
}

div.big-n-stats-container {
	overflow-x: auto;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
	grid-gap: 12px;
	padding: 2px;
	grid-auto-flow: column;
}
</style>
